<div class="center">
    <div class="d-flex justify-content-center" [class._input]="!readonly && !disabled" [class.cursor-pointer]="!readonly && !disabled" *ngIf="!focus">
        <span class="prefix" *ngIf="options?.prefix"><i class="fa fa-{{options?.prefix}}"></i></span>
        <span>{{value || 0 | number}}</span>
        <span class="suffix" *ngIf="options?.suffix">{{options?.suffix}}</span>
        </div>
    <input #input class="text-center" type="text" [value]="value" placeholder="00.00" *ngIf="focus" maxlength="15" (keypress)="isNumeric($event, input.value)" (blur)="setFocus(false)" (change)="emitValue(input.value); setFocus(false)">
</div>